import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { LoadingService } from '../../../../core/services/loading/loading';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDatepickerModule  } from '@angular/material/datepicker';
import { FormUtils } from '../../../../shared/utils';
import { ChangelogService } from '../../../../core/services/changelog/changelog-service';
import { Changelog, ChangelogDTO } from '../../../../core/models/changelog.interface';
import { MatNativeDateModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-changelog-form',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './changelogs-form.html',
  styleUrl: './changelogs-form.scss',
})
export class ChangelogForm {
  changelog: string | null = null;
  errorMsg: string[] | null = null;
  changelogSelected: Changelog | null = null;
  private formBuilder = inject(FormBuilder);

  constructor(
    private dialogRef: MatDialogRef<ChangelogForm>,
    private toastr: ToastrService,
    private serviceChangelog: ChangelogService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.serviceChangelog.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.serviceChangelog.selectedchangelog$.subscribe((changelog) => {
      if (changelog) {
        this.changelog = String(changelog.id);
        this.changelogSelected = changelog;
        this.changelogForm.patchValue({
          ...changelog,
        });
      }
    });
  }

  changelogForm = this.formBuilder.group({
    version: ['', [Validators.required]],
    featureDesc: ['', [Validators.required]],
    bugFixesDesc: ['', [Validators.required]],
    releaseDate: ['', [Validators.required]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

saveChangelog() {
  if (this.changelogForm.invalid) return;
  const formValue = this.changelogForm.value;
  const rawDate = formValue.releaseDate;
  const fechaFormateada = rawDate ? formatDate(rawDate, 'yyyy-MM-dd', 'en-US') : '';

const payload: ChangelogDTO = {
  version: formValue.version ?? '',
  featureDesc: formValue.featureDesc ?? '',
  bugFixesDesc: formValue.bugFixesDesc ?? '',
    releaseDate: fechaFormateada, // Cambia a resealseDate si usas el nombre del backend
  };
  if (!this.changelog) {
    this.loadingService.show(true);
    this.serviceChangelog.createChangelog(payload).subscribe({
      next: (changelog) => {
        this.loadingService.show(false);
        const msg = `El changelog ${changelog.id} fue CREADO correctamente!`;
        this.toastr.success(msg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.dialogRef.close();
      },
      error: ({}: HttpErrorResponse) => {
        if (this.errorMsg) {
          this.loadingService.show(false);
          this.toastr.error('Error: ' + this.errorMsg, undefined, {
            progressBar: true,
            timeOut: 5000,
          });
        }
      },
    });
  } else {
    this.loadingService.show(true);
    const id = Number(this.changelog);
    this.serviceChangelog.updateChangelog(id, { ...payload, id: id }).subscribe({
      next: (changelog) => {
        this.loadingService.show(false);
        const msg = `El changelog ${changelog.id} fue EDITADO correctamente!`;
        this.toastr.success(msg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.dialogRef.close();
      },
      error: ({}: HttpErrorResponse) => {
        if (this.errorMsg) {
          this.loadingService.show(false);
          this.toastr.error('Error: ' + this.errorMsg, undefined, {
            progressBar: true,
            timeOut: 5000,
          });
        }
      },
    });
  }
}
}